const firebaseConfig = {
  apiKey: 'AIzaSyDchJIP3Akcv7VLk2EYYVQ_oZTnVJk3gRQ',
  authDomain: 'reeipo-6cd6c.firebaseapp.com',
  projectId: 'reeipo-6cd6c',
  storageBucket: 'reeipo-6cd6c.firebasestorage.app',
  messagingSenderId: '892044550993',
  appId: '1:892044550993:web:dd2b21a011503bf2bf6970',
  measurementId: 'G-L9QEKZKRF5',
};

export default firebaseConfig;
